/* COMPONENT IMPORTS*/
import ProductDetails from "../../components/ProductDetails/ProductDetails";
import sendLogError from "../../sendLogError";
import ContextConstructor from "../../components/Context/Context";

/* MODULE IMPORTS */
import { withRouter } from "react-router";
import React, { Component } from "react";
import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext,
  DotGroup,
} from "pure-react-carousel";
import Popup from "reactjs-popup";
import CurrentAccountPopUpMobile from "./CurrentAccountPopUpMobile";
import SavingsPlan from "../../components/SavingsPlan/SavingsPlan";
import AddSubscription from "../../components/Subscription/AddSubscription";
/* SAME FOLDER IMPORTS*/

/* CSS IMPORT */
import "./tablestyling.css";
import "pure-react-carousel/dist/react-carousel.es.css";
import closeImg from "../../images/close.png";
import reaplicarImg from "../../images/reaplicar.png";
import reinforceImg from "../../images/reinforce.png";
import newseriesImg from "../../images/newseries.png";

class SavingsItemMobile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      CanReapply: false,
      CanReinforce: false,
      collapsibleOpen: [],
      isOpened: [],
      /**actualDate: null,
            startDateBFTeaser: null,
            endDateBFTeaser: null,
            startDateBF: null,
            endDateBF: null,**/
      actualDateAVOA: null,
      startDateAVOA: null,
      endDateAVOA: null,
        flagAVOA: false,
        showSavingsPlan: false,
        selectedParams: null,
        selectedModalidade: null,
        showAddSubscription: false,
    };
    this.verDetalhesLink = [];
  }

  componentDidMount() {
    this.getAVOApopup();
    //this.GetBlackWeekDates();
  }

  createSubscription(item) {
    var data = {
      subscriptionID: null,
      subscriptionSerieID: null,
      canReapply: false,
      canReinforce: false,
    };
      this.setState({
          selectedParams: data,
          selectedModalidade: item,
          selectedProductName: item?.productName || '',
          showAddSubscription: true

    });
  }

  createSubscriptionRow(item) {
      let modalidade = null;

    this.props.savingsList
      .filter((item) => item.subscriptionsNumber > 0)
      .forEach(function (savings) {
        savings.subscriptions.forEach(function (subscription) {
          if (subscription.subscriptionID === item.subscriptionID) {
            modalidade = savings;
          }
        });
      });

      this.setState({
          selectedParams: item,
          selectedModalidade: modalidade,
          selectedProductName: modalidade?.productName || '',
          showSavingsPlan: true,

    });
  }

  transformSubscribe(a) {
    if (a == "1") return a + " subscrição";
    else return a + " subscrições";
  }

  changeCollapsible() {
    var x = this.state.collapsibleOpen;
    this.setState({
      collapsibleOpen: !x,
    });
  }

  changeSubscribeText(id) {
    if (id == "7385") {
      return "série";
    } else {
      return "inscrição";
    }
  }

  renderDetailsPopup(index, item) {
    return (
      <Popup
        key={index}
        trigger={<div style={{ display: "none" }} id={"popupOpennerTrigger" + index}></div>}
        contentStyle={{ background: "none", border: "none" }}
        modal
        closeOnDocumentClick>
        {(close) => (
          <div className="modalidades-mobile-detalhes">
            <div className="title-section">
              <div className="title-main">
                {item.productName}
                <img
                  src={closeImg}
                  alt="Fechar"
                  onClick={close}
                  style={{ cursor: "pointer" }}
                />
              </div>
              <div className="title-subtitle">
                {this.transformSubscribe(item.subscriptionsNumber)}
              </div>
            </div>
            <div className="montantes-section">
              <div className="tableCapitalCerto-amount">
                <div className="tableCapitalCerto-givenvalue">
                  {new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(
                    item.totalAmounts.totalInvestedAmount,
                  )}
                </div>
                <div className="tableCapitalCerto-subtitle">Montante aplicado</div>
              </div>
              <div className="tableCapitalCerto-amount">
                <div className="tableCapitalCerto-boldvalue-active">
                  {new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(
                    item.totalAmounts.totalReceivedAmount,
                  )}
                </div>
                <div className="tableCapitalCerto-subtitle">Rendimento Bruto</div>
              </div>
            </div>
            {item.subscriptions.map((subscription, indexSubscription) => (
              <div className="serie-mobile-wrapper">
                <div className="serie-mobile">
                  <div className="serie-mobile-first-div">
                    <ProductDetails
                      subscriptionSerieID={subscription.subscriptionSerieID}
                      productID={item.productID}
                      subscriptionsSerie={subscription.subscriptionSerie}
                      subscriptionType="serie"
                      subscriptionState={subscription.subscriptionState}
                      subscriptionNumber={subscription.subscriptionNumber}
                      currentAccount={subscription.currentAccount}
                    />
                    {subscription.canReapply ? (
                      <div className="reaplicar-reforcar-buttons-mobile">
                        <img
                          src={reaplicarImg}
                          style={{ cursor: "pointer" }}
                          width="98px"
                          height="30px"
                          onClick={this.createSubscriptionRow.bind(this, subscription)}></img>
                        <CurrentAccountPopUpMobile CurrentAccountList={subscription.currentAccount}>
                          {" "}
                        </CurrentAccountPopUpMobile>
                      </div>
                    ) : subscription.canReinforce ? (
                      <div className="reaplicar-reforcar-buttons-mobile">
                        <img
                          src={reinforceImg}
                          style={{ cursor: "pointer" }}
                          width="98px"
                          height="30px"
                          onClick={this.createSubscriptionRow.bind(this, subscription)}></img>{" "}
                        <CurrentAccountPopUpMobile CurrentAccountList={subscription.currentAccount}>
                          {" "}
                        </CurrentAccountPopUpMobile>
                      </div>
                    ) : (
                      <div style={{ padding: "5% 10% 0% 4%" }}>
                        {" "}
                        <CurrentAccountPopUpMobile CurrentAccountList={subscription.currentAccount}>
                          {" "}
                        </CurrentAccountPopUpMobile>{" "}
                      </div>
                    )}
                  </div>
                  <div className="subscricao-detalhe">
                    <div className="label">Montante Aplicado</div>
                    <div className="value">
                      {new Intl.NumberFormat("de-DE", {
                        style: "currency",
                        currency: "EUR",
                      }).format(subscription.investedAmount)}
                    </div>
                  </div>
                  <div className="subscricao-detalhe">
                    <div className="label">Rendimento Acumulado</div>
                    <div className="value acumulado">
                      {new Intl.NumberFormat("de-DE", {
                        style: "currency",
                        currency: "EUR",
                      }).format(subscription.receivedAmount)}
                    </div>
                  </div>
                  <div className="subscricao-detalhe">
                    <div className="label">Data Subscrição</div>
                    <div className="value data">
                      {new Intl.DateTimeFormat("pt-PT").format(
                        new Date(subscription.subscriptionDate),
                      )}
                    </div>
                  </div>
                  {item.productID == "7385" ? (
                    <div className="subscricao-detalhe">
                      <div className="label"> Data Vencimento</div>
                      <div className="value data">
                        {new Intl.DateTimeFormat("pt-PT").format(
                          new Date(subscription.subscriptionEndDate),
                        )}
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            ))}
            <div className="new-serie-wrapper">
              <div className="new-series">
                <div style={{ width: "50%" }}>
                  <div className="new-series-text">
                    Subscrever nova {this.changeSubscribeText(item.productID)}
                  </div>
                </div>
                <div style={{ width: "50%" }}>
                  <img
                    src={newseriesImg}
                    onClick={this.createSubscription.bind(this, item)}
                    className="new-series-img"
                    width="50px"
                    height="50px"></img>
                </div>
              </div>
            </div>
          </div>
        )}
      </Popup>
    );
  }

  openPopup(index) {
    //faz triger do click para abrir os detalhes especificos
    document.getElementById("popupOpennerTrigger" + index).click();
  }

    render() {
        const { showSavingsPlan, showAddSubscription, selectedParams, selectedModalidade, savingsList, nSavingsWithSubscriptions } = this.state;

     
        if (showSavingsPlan && selectedParams && selectedModalidade) {
            return (
                <SavingsPlan
                    params={selectedParams}
                    modalidade={selectedModalidade}
                    productName={this.state.selectedProductName}
                    onClose={() => this.setState({ showSavingsPlan: false })}
                />
            );
        }

   
        if (showAddSubscription && selectedParams && selectedModalidade) {
            return (
                <AddSubscription
                    params={selectedParams}
                    modalidade={selectedModalidade}
                    productName={this.state.selectedProductName}
                    onClose={() => this.setState({ showAddSubscription: false })}
                />
            );
        }
        let itemsToRender = this.props.savingsList.filter((item) => item.subscriptionsNumber > 0);

        return (
            <React.Fragment>
                {itemsToRender.map((item, index) => this.renderDetailsPopup(index, item))}

            <div className="carousel-wrapper">
                <CarouselProvider
                    naturalSlideWidth={400}
                    naturalSlideHeight={500}
                    totalSlides={this.props.nSavingsWithSubscriptions}
                    visibleSlides={1}>
                    <Slider>
                        {itemsToRender.map((item, index) => (
                            <Slide key={index} index={index}>
                                <div className="modalidades modalidades-mobile">
                                    <div className="tableCapitalCerto">
                                        <div className="tableCapitalCerto-orangeback">
                                            <div className="tableCapitalCerto-title">{item.productName}</div>
                                            <div className="tableCapitalCerto-titlesubtitle">
                                                {this.transformSubscribe(item.subscriptionsNumber)}
                                            </div>
                                        </div>
                                        <div className="tableCapitalCerto-amount">
                                            <div className="tableCapitalCerto-givenvalue">
                                                {new Intl.NumberFormat("de-DE", {
                                                    style: "currency",
                                                    currency: "EUR",
                                                }).format(item.totalAmounts.totalInvestedAmount)}
                                            </div>
                                            <div className="tableCapitalCerto-subtitle">Montante aplicado</div>
                                        </div>
                                        <div className="tableCapitalCerto-amount">
                                            <div className="tableCapitalCerto-boldvalue-active">
                                                {new Intl.NumberFormat("de-DE", {
                                                    style: "currency",
                                                    currency: "EUR",
                                                }).format(item.totalAmounts.totalReceivedAmount)}
                                            </div>
                                            <div className="tableCapitalCerto-subtitle">Rendimento Bruto</div>
                                        </div>
                                        <div
                                            id="createSubscriptionMobile"
                                            onClick={() => this.createSubscription(item)}
                                        >
                                            <img src={newseriesImg} alt="Nova Série" />
                                            <div className="createSubscriptionMobile-text">Subscrever</div>
                                        </div>
                                        <div
                                            onClick={() => this.openPopup(index)}
                                            className="consultar-detalhes"
                                        >
                                            Ver detalhe
                                        </div>
                                    </div>
                                </div>
                            </Slide>
                        ))}
                    </Slider>
                    <DotGroup />
                </CarouselProvider>
                </div>
            </React.Fragment>
        );
    }

  /**async GetBlackWeekDates() {

        const atoken = authentication.getAccessToken();

        const headers = { Authorization: `Bearer ${atoken}` };

        const response = await fetch("/Elections/GetBlackWeekDates", {

            headers,

        });

        if (response.status !== 200) {

        } else {

            const data = await response.json();


            this.setState({
                actualDate: data.actualDate,
                startDateBFTeaser: data.startDateBFTeaser,
                endDateBFTeaser: data.endDateBFTeaser,
                startDateBF: data.startDateBF,
                endDateBF: data.endDateBF,
            });

        }

    }**/
  async getAVOApopup() {
    try {
        const { idToken } = this.context;

        const headers = {
            Authorization: `Bearer ${idToken}`,
        };

        const response = await fetch("/Elections/GetAVOADates", { headers });

        if (!response.ok) {
            throw new Error(`Erro HTTP: ${response.status}`);
        }

        const data = await response.json();

        this.setState({
            actualDateAVOA: data?.actualDateAVOA || null,
            startDateAVOA: data?.startDateAVOA || null,
            endDateAVOA: data?.endDateAVOA || null,
            flagAVOA: data?.flagAVOA ?? false,
        });

    } catch (error) {
        console.error("Error fetching AVOA popup:", error);

        sendLogError(error.message, "getAVOApopup");
    }
  }
}

SavingsItemMobile.contextType = ContextConstructor;

export default withRouter(SavingsItemMobile);
